import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { ReactComponent as PartnerFusionSvg } from "assets/images/icons/partners_fusion.svg";
import Alert from "components/shared/Alert";

interface IFusionPartnerBoxProps {
  hideDismiss?: boolean;
  footer?: () => React.ReactChild;
}

export const FusionPartnerBox: React.FC<IFusionPartnerBoxProps> = ({
  hideDismiss = false,
  footer,
}) => {
  const classes = useStyles();

  return (
    <Alert
      severity="info"
      icon={false}
      classes={{ message: classes.message }}
      noDismiss={hideDismiss}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="16px"
      >
        <Box
          color="secondary.main"
          display="flex"
          alignItems="center"
          component="p"
          margin={0}
        >
          <PartnerFusionSvg fill="secondary.main" />
          <Box marginLeft={1} component="span">
            <Typography variant="subtitle2" component="span">
              Fusion Partner
            </Typography>
          </Box>
        </Box>
        <Box component="p" margin={0}>
          Fusion detection with AMP<sup>&trade;</sup> chemistry only requires
          one partner to be targeted.
        </Box>
        <Typography variant="inherit" component="p">
          Known fusion partners are suggested when a gene query is not included
          in our predesigned, functionally-tested content.
        </Typography>
        {!!footer ? footer() : <></>}
      </Box>
    </Alert>
  );
};

const useStyles = makeStyles({
  message: {
    fontSize: 16,
    letterSpacing: 0.5,
    lineHeight: "23px",
  },
});
